function loadDropdownList() {
    var prevUrl = window.location.href;
    window.location.href = prevUrl;
}

function addToken(form) {
    //Add token
    var token =
        $('<input>', {
            'type': 'hidden',
            'name': '_token',
            'value': $('meta[name="_token"]').attr('content')
        });
    form.remove('input[name="_token"]').append(token);

    return form;
}


function updateDropdown(id) {

    var myForm = $('#dropdownEditForm')[0];
    var myData = new FormData(myForm);

    var form = $(myForm);

    if (id > 0) {
        myData.append('_method', 'PUT');
        $.ajax({
            type: 'POST',
            url: '/adm/dropdowns/' + id,
            processData: false,
            contentType: false,
            cache: false,
            enctype: 'multipart/form-data',
            data: myData,
            async: false

        }).success(function (data) {
            var MyId = id;
            swal({
                    title: "Success",
                    text: "Item updated",
                    type: "success",
                    confirmButtonColor: "#286090",
                    confirmButtonText: "Ok",
                    // closeOnConfirm: false
                },
                function (id) {
                    location.reload();
                });
        }).error(function (jqXHR, myData) {
            ppnotify('alert', {
                title: 'Error',
                message: 'Error updating item',
                type: 'error'
            });
        });
    }
}

function cancelDropdownUpdate(id) {
    if (id !== undefined) {
        removeDropdownEditForm(id)
    } else {
        removeDropdownAddForm();
    }
}

function removeDropdownAddForm() {
    $('#newDropdownId').html('');
}

function removeDropdownEditForm(id) {
    $('#' + id + 'DD').css('display', 'none');
    $('#' + id + 'DDForm').html('');
}

function toggleDropdownAddButton() {
    var dropdownType = $('#dropdown-model-select').val();
    if (dropdownType > 0) {
        $('#addDropdownButton').css('visibility', 'visible');
    } else {
        $('#addDropdownButton').css('visibility', 'hidden');
    }
}

function addDropdownTerm() {
    var model = $('#dropdown-model-select').val();
    var url = '/adm/dropdowns/' + model + '/create';
    $('#newDropdownId').html('').load(url, function () {
        turnOnTooltips();
    }).val();
}

function storeDropdown(model) {
    var myForm = $('#dropdownAddForm')[0];
    var myData = new FormData(myForm);
    var form = $(myForm);
    // myData.append('_method', 'PUT');

    $.ajax({
        type: 'POST',
        url: '/adm/dropdowns',
        processData: false,
        contentType: false,
        cache: false,
        enctype: 'multipart/form-data',
        data: myData,
        async: false

    }).success(function (data) {
        ppnotify('confirm', {
            title: 'Record added.',
            text: 'Would you like to add another?',
            type: 'info',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            closeOnConfirm: true,
            closeOnCancel: true,
            callback: function (isConfirm) {
                if (isConfirm) {
                    let ddType = $('#dropdown-model-select option:selected').text();
                    // build the new row and prepend it to the current page's table.
                    myHtml = '<tr>';
                    myHtml += '<td>' + data.name + '</td>';
                    myHtml += '<td>' + ddType + '</td>';
                    myHtml += '<td>';
                    myHtml += '<a title="Edit" onclick="editDropdownTerm('+ data.id +')"><i class="fa fa-edit"></i></a>&nbsp;&nbsp;';
                    // myHtml += '<a title="Delete" data-method="delete" data-confirm="admin.dropdowns.confirm_delete" href="'+ getBaseUrl() +'adm/dropdowns/' + data.id + '"><i class="fa fa-times"></i></a>';
                    myHtml += '</td>';
                    myHtml += '</tr><tr id="' + data.id + 'DD" style="display:none;"><td id="' + data.id + 'DDForm" colspan="3">';
                    myHtml += ' </td></tr>';
                    $('#dropdown-list-table tbody').prepend(myHtml);
                    addDropdownTerm();
                    turnOnTooltips();

                } else {
                    location.reload();
                }
            }
        });

    }).error(function (result) {

        ppnotify('alert', {
            title: 'Error',
            message: 'Error updating item',
            type: 'error'
        });
    });

}

function editDropdownTerm(id) {
    var url = '/adm/dropdowns/' + id + '/edit';
    $('#' + id + 'DD').css('display', 'table-row');
    $('#' + id + 'DDForm').html('').load(url, function () {
        turnOnTooltips();
    }).val();
}

$(document).ready(function () {
    toggleDropdownAddButton();
    $(document).on("change", "#dropdown-model-select", function () {
        toggleDropdownAddButton();
    });

    $('#dropdown-model-select').on('change', function(e){
        this.form.submit()
    });

});

